<template>
  <div class="py-4 border-b border-gray-300">
    <div
      v-if="order.payment_status === 'slip_waiting'"
      class="text-sm text-red-500 font-medium text-right mt-1"
    >
      ⏳ รอการชำระเงิน
    </div>
    <div
      v-else-if="order.payment_status === 'slip_checking'"
      class="text-sm text-yellow-600 font-medium text-right mt-1"
    >
      🕒 รอแอดมินตรวจสอบสลิป
    </div>
    <div
      v-else-if="order.payment_status === 'paid'"
      class="text-sm text-green-600 font-medium text-right mt-1"
    >
      ✅ ชำระเงินแล้ว
    </div>

    <div class="text-sm font-bold text-gray-800">🧾 รหัสคำสั่งซื้อ: {{ order.order_id }}</div>
    <div class="text-sm text-gray-600 mb-2">
      วันที่: {{ new Date(order.created_at).toLocaleDateString("th-TH") }}
    </div>

    <div class="text-sm text-gray-700 font-semibold mb-1">รายการสินค้า:</div>
    <ul class="ml-4 text-sm text-gray-700 list-disc">
      <li v-for="(item, index) in order.items" :key="index">
        {{ item.title }} x {{ item.quantity }} =
        {{ (item.quantity * item.selling_price).toLocaleString() }} บาท
      </li>
    </ul>
    <div class="text-sm font-bold text-right mt-2 text-gray-800">
      รวมทั้งหมด: ฿{{ order.total_price?.toLocaleString() ?? "0" }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
};
</script>